import { DOCUMENT } from '@angular/common';
import { afterNextRender, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, NavigationSkipped, Router, RouterLink } from '@angular/router';
import { filter } from 'rxjs';

import { environment } from '../../../environments/environment';
import { AdminService } from '../../service/admin.service';
import { WebsiteService } from '../../service/website.service';
import { HeaderCartIconComponent } from './header-cart.component';
import { SocialComponent } from './social.component';

@Component({
  selector: 'page-header',
  imports: [RouterLink, SocialComponent, HeaderCartIconComponent],
  host: {
    style: 'display: contents'
  },
  template: `
    <!-- Header -->
    <header class="header1">
      <!-- Header desktop -->
      <div class="container-menu-header">
        <div class="topbar">
          <div class="topbar-social">
            <social itemClass="topbar-social-item fa" />
          </div>

          @if (website().specialText) {
            <span class="topbar-child1" [innerHTML]="website().specialText"></span>
          }

          <div class="topbar-child2">
            <span class="topbar-email">
              <i class="fa fa-phone" aria-hidden="true"></i>&nbsp;&nbsp;
              <a class="s-text7" [href]="'tel:' + website().phone">{{website().phone}}</a>
            </span>
          </div>
        </div>

        <div class="wrap_header">
          <!-- Logo -->
          <a routerLink="/" class="logo">
            <img [src]="website().logo" [alt]="website().name">
          </a>

          <!-- Menu -->
          <div class="wrap_menu">
            <nav class="menu">
              <ul class="main_menu">
                <li>
                  <a routerLink="/">Головна</a>
                </li>

                <li>
                  <a routerLink="/products">Товари</a>
                  @if (website().categories?.length) {
                    <ul class="sub_menu bgdark">
                      <li class="header-category"><a routerLink="/products">Усі товари</a></li>
                      @for (category of website().categories ?? []; track $index) {
                        <li class="header-category"><a [routerLink]="'/' + category.code">{{category.name}}</a></li>
                      }
                    </ul>
                  }
                </li>

                <li>
                  <a routerLink="/about">Про нас</a>
                </li>

                @if (website().websitePages?.length) {
                  <li>
                    <a [routerLink]="'/' + website().websitePages![0].code">{{website().websitePages![0].name}}</a>
                    <ul class="sub_menu bgdark">
                      @for (page of website().websitePages ?? []; track $index) {
                        <li class="header-category"><a [routerLink]="'/' + page.code">{{page.name}}</a></li>
                      }
                      <li class="header-category"><a routerLink="/questions">Запитання</a></li>
                    </ul>
                  </li>
                } @else {
                  <li>
                    <a routerLink="/questions">Запитання</a>
                  </li>
                }

                <li>
                  <a routerLink="/contacts">Контакти</a>
                </li>

                @if (isAdmin()) {
                  <li class="sale-noti admin-menu">
                    <a target="_blank" rel="noopener noreferrer" [href]="adminPanelUrl">Адміністратор</a>
                    <ul class="sub_menu bgdark">
                      <li class="header-category">
                        <a target="_blank" rel="noopener noreferrer" [href]="adminPanelUrl">Адміністративна панель</a>
                      </li>
                      <li class="header-category"><a routerLink="/product-hierarchy">Ієрархія продуктів</a></li>
                      <li class="header-category"><a routerLink="/orders">Список замовлень</a></li>
                    </ul>
                  </li>
                }
              </ul>
            </nav>
          </div>

          <!-- Header Icon -->
          <div class="header-icons">
            <span class="linedivide1"></span>

            <header-cart-icon />
          </div>
        </div>
      </div>

      <!-- Header Mobile -->
      <div class="wrap_header_mobile">
        <!-- Logo moblie -->
        <a routerLink="/" class="logo-mobile">
          <img [src]="website().logo" [alt]="website().name">
        </a>

        <!-- Button show menu -->
        <div class="btn-show-menu">
          <!-- Header Icon mobile -->
          <div class="header-icons-mobile">
            <span class="linedivide2"></span>

            <header-cart-icon />
          </div>

          <div class="btn-show-menu-mobile hamburger hamburger--squeeze">
            <span class="hamburger-box">
              <span class="hamburger-inner"></span>
            </span>
          </div>
        </div>
      </div>

      <!-- Menu Mobile -->
      <div class="wrap-side-menu">
        <nav class="side-menu">
          <ul class="main-menu">
            @if (website().specialText) {
              <li class="item-topbar-mobile p-l-20 p-t-8 p-b-8">
                <span class="topbar-child1" [innerHTML]="website().specialText"></span>
              </li>
            }

            <li class="item-topbar-mobile p-l-20 p-t-8 p-b-8">
              <div class="topbar-child2-mobile">
                <span class="topbar-email">
                  <i class="fa fa-phone" aria-hidden="true"></i>&nbsp;&nbsp;
                  <a class="s-text7" [href]="'tel:' + website().phone">{{website().phone}}</a>
                </span>
              </div>
            </li>

            <li class="item-topbar-mobile p-l-10">
              <div class="topbar-social-mobile">
                <social itemClass="topbar-social-item fa" />
              </div>
            </li>

            <li class="item-menu-mobile bglight">
              <a routerLink="/">Головна</a>
            </li>

            <li class="item-menu-mobile bglight">
              <a [routerLink]="website().categories?.length ? null : '/products'"
                 (click)="openSubmenu($event)">Товари</a>
              @if (website().categories?.length) {
                <ul class="sub-menu">
                  <li class="header-category"><a routerLink="/products">Усі товари</a></li>
                  @for (category of website().categories ?? []; track $index) {
                    <li class="header-category"><a [routerLink]="'/' + category.code">{{category.name}}</a></li>
                  }
                </ul>
                <i class="arrow-main-menu fa fa-angle-right" aria-hidden="true"></i>
              }
            </li>

            <li class="item-menu-mobile bglight">
              <a routerLink="/about">Про нас</a>
            </li>

            @if (website().websitePages?.length) {
              <li class="item-menu-mobile bglight">
                <a [routerLink]="null" (click)="openSubmenu($event)">{{website().websitePages![0].name}}</a>
                <ul class="sub-menu">
                  @for (page of website().websitePages ?? []; track $index) {
                    <li class="header-category"><a [routerLink]="'/' + page.code">{{page.name}}</a></li>
                  }
                  <li class="header-category"><a routerLink="/questions">Запитання</a></li>
                </ul>
                <i class="arrow-main-menu fa fa-angle-right" aria-hidden="true"></i>
              </li>
            } @else {
              <li class="item-menu-mobile bglight">
                <a routerLink="/questions">Запитання</a>
              </li>
            }

            <li class="item-menu-mobile bglight">
              <a routerLink="/contacts">Контакти</a>
            </li>

            @if (isAdmin()) {
              <li class="item-menu-mobile bglight admin-menu">
                <a routerLink="/orders">Список замовлень</a>
              </li>
              <li class="item-menu-mobile bglight admin-menu">
                <a routerLink="/product-hierarchy">Ієрархія продуктів</a>
              </li>
            }
          </ul>
        </nav>
      </div>
    </header>
    `
})
export class HeaderComponent {

  readonly website = inject(WebsiteService).current;
  readonly isAdmin = inject(AdminService).isAdmin;
  /** The plusminus panel is served by unimarket-api, not by the storefront. */
  readonly adminPanelUrl = environment.apiUrl + '/admin';

  private document = inject(DOCUMENT);

  constructor() {
    const navigations = inject(Router).events.pipe(
      filter(event => event instanceof NavigationEnd || event instanceof NavigationSkipped),
      takeUntilDestroyed(inject(DestroyRef)));
    afterNextRender(() => navigations.subscribe(() => {
      this.closeSideMenu();
      this.dismissDropdown();
    }));
  }

  /**
   * A mobile entry that owns a submenu opens the submenu instead of its own page: on a phone the
   * parent is the only way to reach the children, and a tap that navigates takes the menu with
   * it. The arrow beside it already does this, so the tap is forwarded to the arrow -- the
   * theme's own handler, with its slide and its rotation, rather than a second one here.
   */
  openSubmenu(event: Event): void {
    const arrow = (event.currentTarget as HTMLElement).parentElement
      ?.querySelector<HTMLElement>('.arrow-main-menu');
    if (arrow) {
      event.preventDefault();
      arrow.click();
    }
  }

  private closeSideMenu(): void {
    const side = this.document.querySelector<HTMLElement>('.wrap-side-menu');
    if (side) {
      side.style.display = 'none';
    }
    this.document.querySelector('.btn-show-menu-mobile')?.classList.remove('is-active');
    this.document.querySelectorAll<HTMLElement>('.side-menu .sub-menu')
      .forEach(submenu => submenu.style.display = '');
    this.document.querySelectorAll('.arrow-main-menu')
      .forEach(arrow => arrow.classList.remove('turn-arrow'));
  }

  private dismissDropdown(): void {
    const menu = this.document.querySelector('.wrap_menu');
    // Only a click inside a dropdown leaves one open under the pointer; pointerleave then clears it
    if (!menu?.querySelector('.sub_menu:hover')) {
      return;
    }
    menu.classList.add('menu-dismissed');
    const restore = () => menu.classList.remove('menu-dismissed');
    menu.addEventListener('pointerleave', restore, { once: true });
  }

}
